function cov_1i7m4emhny() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Table/TableHeading.tsx";
  var hash = "d4433ed748eb4de2c9b3e9cd36a75e6d2ea61fb9";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Table/TableHeading.tsx",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 28
        },
        end: {
          line: 19,
          column: 2
        }
      },
      "1": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 54
        }
      },
      "2": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 18,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 64
          },
          end: {
            line: 9,
            column: 65
          }
        },
        loc: {
          start: {
            line: 9,
            column: 80
          },
          end: {
            line: 19,
            column: 1
          }
        },
        line: 9
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d4433ed748eb4de2c9b3e9cd36a75e6d2ea61fb9"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1i7m4emhny = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1i7m4emhny();
import "core-js/modules/es.object.assign.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { forwardRef } from '@chakra-ui/system';
import { bricks } from "../../system/bricks.types.mjs";
import { useStyleConfig } from "../../system/utils/index.mjs";
export var TableHeading = (cov_1i7m4emhny().s[0]++, forwardRef(function (props, ref) {
  cov_1i7m4emhny().f[0]++;
  var styles = (cov_1i7m4emhny().s[1]++, useStyleConfig('TableHeading', props));
  cov_1i7m4emhny().s[2]++;
  return /*#__PURE__*/React.createElement(bricks.th, _extends({
    ref: ref
    // __css has a lower priority than sx
    ,
    __css: styles
  }, props));
}));